export const Checkbox = {
    variants: {
        ironhack: {
            control: {
                _checked: {
                    _disabled: {
                        bg: 'transparent',
                        borderColor: 'stroke.medium',
                        color: 'stroke.medium'
                    },
                    _hover: {
                        bg: 'transparent',
                        borderColor: 'stroke.interactive'
                    },
                    bg: 'transparent',
                    borderColor: 'stroke.interactive',
                    color: 'stroke.interactive'
                },
                _disabled: {
                    bg: 'transparent',
                    borderColor: 'stroke.medium',
                    color: 'stroke.medium'
                },
                _focusVisible: {
                    boxShadow: 'var(--chakra-colors-purple-100) 0px 0px 0px 4px'
                },
                _indeterminate: {
                    bg: 'transparent',
                    borderColor: 'stroke.interactive',
                    color: 'stroke.interactive'
                },
                _invalid: {
                    bg: 'transparent',
                    borderColor: 'stroke.error',
                    color: 'stroke.error'
                },
                border: '2px solid',
                borderColor: 'stroke.dark',
                borderRadius: '3px'
            },
            label: {
                textStyle: 'm',
                _disabled: {
                    color: 'text.tertiary',
                    opacity: 1
                }
            }
        },
        inverse: {
            control: {
                _checked: {
                    _disabled: {
                        bg: 'transparent',
                        borderColor: 'stroke.medium',
                        color: 'stroke.medium'
                    },
                    _hover: {
                        bg: 'transparent',
                        borderColor: 'stroke.white'
                    },
                    bg: 'transparent',
                    borderColor: 'stroke.white',
                    color: 'stroke.white'
                },
                _disabled: {
                    bg: 'transparent',
                    borderColor: 'stroke.medium',
                    color: 'stroke.medium'
                },
                _focusVisible: {
                    boxShadow: 'var(--chakra-colors-purple-100) 0px 0px 0px 4px'
                },
                _indeterminate: {
                    bg: 'transparent',
                    borderColor: 'stroke.interactive',
                    color: 'stroke.interactive'
                },
                _invalid: {
                    bg: 'transparent',
                    borderColor: 'stroke.error',
                    color: 'stroke.error'
                },
                border: '2px solid',
                borderColor: 'stroke.white',
                borderRadius: '3px'
            },
            label: {
                textStyle: 'm',
                _disabled: {
                    color: 'text.inverse',
                    opacity: 1
                }
            }
        }
    },
    parts: [
        'icon',
        'container',
        'control',
        'label'
    ],
    sizes: {
        s: {
            control: {
                h: '20px',
                w: '20px'
            }
        },
        l: {
            control: {
                h: '24px',
                w: '24px'
            }
        }
    },
    defaultProps: {
        variant: 'ironhack',
        size: 's'
    }
};

//# sourceMappingURL=checkbox.js.map